export class Resource {
    FileName!: string;
    Data!: string;
}